import { render, staticRenderFns } from "./CardPsy.vue?vue&type=template&id=2186de37&scoped=true&"
import script from "./CardPsy.vue?vue&type=script&lang=js&"
export * from "./CardPsy.vue?vue&type=script&lang=js&"
import style0 from "./CardPsy.vue?vue&type=style&index=0&id=2186de37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186de37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCol,VIcon,VImg,VRow})
